import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import t from "@constants/localization";
import { actions as authActions } from "@reducers/authReducer";
import useCustomAlert from "./useCustomAlert";

const PATH = "common";

const useLeaderState = () => {
  const dispatch = useDispatch();
  const { leader_state, is_suspended } = useSelector(
    ({ auth: { user } }) => user,
  );
  const { LEADER_STATE_MESSAGES = {} } = useSelector(
    (state) => state.configReducer.appSettings,
  );

  let CAN_ACCESS_APP = true;

  if (
    leader_state === "PAYMENT_DONE" ||
    leader_state === "PAYMENT_PENDING" ||
    leader_state === "PAYMENT_REFUNDED" ||
    leader_state === "ZERO_PAYMENT"
  ) {
    CAN_ACCESS_APP = false;
  }

  const getMessageFromState = () => {
    if (leader_state === "PAYMENT_DONE") {
      return LEADER_STATE_MESSAGES.PAYMENT_DONE;
    }
    if (
      leader_state === "PAYMENT_PENDING" ||
      leader_state === "PAYMENT_REFUNDED"
    ) {
      return LEADER_STATE_MESSAGES.PAYMENT_PENDING;
    }
    if (leader_state === "LEADER_SUSPENDED" || is_suspended) {
      return LEADER_STATE_MESSAGES.LEADER_SUSPENDED;
    }
    return LEADER_STATE_MESSAGES.CANNOT_USE_APP;
  };

  const [dontAllowToUseFeature] = useCustomAlert({
    title: "",
    subTitle: getMessageFromState(),
    cancelable: true,
    okText: t(`${PATH}/ok`),
    showCancel: false,
  });

  const canLeaderUseApp = (dont_show_message = false) => {
    if (!CAN_ACCESS_APP) {
      !dont_show_message && dontAllowToUseFeature();
      return false;
    }
    return true;
  };

  const canShareShop = () => {
    if (is_suspended || leader_state === "LEADER_SUSPENDED") {
      dispatch(authActions.showSuspensionModal(true));
      return false;
    }
    return true;
  };

  const canUseFeature = (leaderStates = []) => {
    if (
      leader_state === "LEADER_APPROVED" ||
      leader_state === "VACATIONING" ||
      leader_state === "VACATIONING_WITHOUT_COMMISSION"
    ) {
      return true;
    } else if (leaderStates.includes(leader_state)) {
      return true;
    }
    return false;
  };

  return {
    canLeaderUseApp,
    canShareShop,
    canUseFeature,
  };
};
export default useLeaderState;
